import React from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { translateText } from '../utils/functions';
import { allowedFilterContentProps } from '../utils/allowedPropTypes';

const ColumnFilterContent = (
  {
    filteredColumnId,
    filteredColumnTitle,
    languageCode = 'en',
    filterOptions,
    placeholderContent,
    isFilterMode,
    setFilterMode,
    filterTable,
    renderOptionLabel
  }
) => {
  const moduleName = 'columnFilter';
  const columnName = filteredColumnTitle.toLowerCase();

  if (isFilterMode) {
    const attributesTypeahead = {
      id: `filter-${filteredColumnId}`,
      options: filterOptions,
      clearButton: true,
      autoFocus: true,
      emptyLabel: translateText(
        moduleName,
        'text-no-matching-option',
        languageCode,
        { columnName }
      ),
      onChange: filterInputs => {
        const explodedDataPath = filteredColumnId.split('-');
        explodedDataPath.shift();
        filterTable(filterInputs[0] || null, explodedDataPath.join('-'));
      }
    };

    if (renderOptionLabel) {
      attributesTypeahead.labelKey = renderOptionLabel;
    }

    return (
      <React.Fragment>
        <Typeahead {...attributesTypeahead} />

        <button
          className='button-wrap no-shrink'
          onClick={() => setFilterMode(false)}
          title={translateText(
            moduleName,
            'button-toggler-aria',
            languageCode,
            { columnName }
          )}
        >
          <FontAwesomeIcon icon='times' />
        </button>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {placeholderContent}

      <button
        className='button-wrap'
        onClick={() => setFilterMode(true)}
        title={translateText(
          moduleName,
          'button-opener-aria',
          languageCode,
          { columnName }
        )}
      >
        <FontAwesomeIcon icon='search' />
      </button>
    </React.Fragment>
  );
};

ColumnFilterContent.propTypes = allowedFilterContentProps;

export default ColumnFilterContent;